import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

/**
 * Custom hook for responsive design using MUI breakpoints.
 * Provides boolean flags for common breakpoint checks.
 */
export const useResponsive = () => {
  const theme = useTheme();

  // Check if screen is at or above breakpoint
  const isXs = useMediaQuery(theme.breakpoints.up('xs'));
  const isSm = useMediaQuery(theme.breakpoints.up('sm'));
  const isMd = useMediaQuery(theme.breakpoints.up('md'));
  const isLg = useMediaQuery(theme.breakpoints.up('lg'));
  const isXl = useMediaQuery(theme.breakpoints.up('xl'));

  // Check if screen is below breakpoint
  const isBelowSm = useMediaQuery(theme.breakpoints.down('sm'));
  const isBelowMd = useMediaQuery(theme.breakpoints.down('md'));
  const isBelowLg = useMediaQuery(theme.breakpoints.down('lg'));

  // Common device-type checks
  const isMobile = isBelowSm; // < 600px
  const isTablet = isSm && isBelowMd; // 600px - 959px
  const isDesktop = isMd; // >= 960px

  return {
    // Breakpoint up checks
    isXs,
    isSm,
    isMd,
    isLg,
    isXl,
    // Breakpoint down checks
    isBelowSm,
    isBelowMd,
    isBelowLg,
    // Device type helpers
    isMobile,
    isTablet,
    isDesktop,
  };
};
